import styled from 'styled-components';



export const FavoriteEventOpacityView = styled.div`
  display: flex;
  flex-direction: column;
  opacity: 0.4;
`;
